/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "product/models.proto" (package "rd.product", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Vendor } from "../vendors/models_pb";
import { Money } from "../proto/money/models_pb";
import { FractionalMoney } from "../proto/money/models_pb";
import { GiftCard_Type } from "../giftcard/models_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Product represents a good sold by a Company.
 *
 * @generated from protobuf message rd.product.Product
 */
export interface Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 6
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID matched_cost_product_id = 8
     */
    matchedCostProductId?: UUID;
    /**
     * First identifier in the list is the primary identifier
     *
     * @generated from protobuf field: repeated string identifiers = 11
     */
    identifiers: string[];
    /**
     * @generated from protobuf field: string name = 12
     */
    name: string;
    /**
     * @generated from protobuf field: bool is_commissionable = 14
     */
    isCommissionable: boolean;
    /**
     * @generated from protobuf field: bool is_tintable = 15
     */
    isTintable: boolean;
    /**
     * @generated from protobuf field: bool is_active = 16
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: repeated rd.product.Product.Cost costs = 18
     */
    costs: Product_Cost[];
    /**
     * @generated from protobuf field: map<string, rd.product.Product.OrderSettings> order_settings_by_location_id = 22
     */
    orderSettingsByLocationId: {
        [key: string]: Product_OrderSettings;
    };
    /**
     * @generated from protobuf field: map<string, string> bin_locations_by_location_id = 24
     */
    binLocationsByLocationId: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: repeated rd.product.Product.QuantityBreak quantity_breaks = 25
     */
    quantityBreaks: Product_QuantityBreak[];
    /**
     * for delineating items not inteded to be kept in any kind of stock, like
     * labor fees
     *
     * @generated from protobuf field: bool is_non_stock = 28
     */
    isNonStock: boolean;
    /**
     * @generated from protobuf field: rd.product.Product.TaxStatus tax_status = 29
     */
    taxStatus: Product_TaxStatus;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID department_id = 30
     */
    departmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID class_id = 31
     */
    classId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fineline_id = 32
     */
    finelineId?: UUID;
    /**
     * @generated from protobuf field: string notes = 33
     */
    notes: string;
    /**
     * @generated from protobuf field: string sales_reminder = 34
     */
    salesReminder: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 35
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: string template_sale_product_notes = 36
     */
    templateSaleProductNotes: string;
    /**
     * @generated from protobuf field: string template_order_product_notes = 37
     */
    templateOrderProductNotes: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal restock_fee_rate = 40
     */
    restockFeeRate?: Decimal; // used for special order returns
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_form_id = 41
     */
    saleFormId?: UUID;
    /**
     * for items that require orders to be placed
     *
     * @generated from protobuf field: bool is_special_orderable_v2 = 42
     */
    isSpecialOrderableV2: boolean;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_quantity_v2 = 43
     */
    caseQuantityV2?: Decimal;
    /**
     * @generated from protobuf field: bool allow_decimal_quantities = 44
     */
    allowDecimalQuantities: boolean;
    /**
     * @generated from protobuf field: bool should_not_nest = 45
     */
    shouldNotNest: boolean;
    /**
     * @generated from protobuf field: repeated rd.product.Product.UnitConversion unit_conversions = 46
     */
    unitConversions: Product_UnitConversion[];
    /**
     * @generated from protobuf field: map<int32, rd.product.Product.UnitConversion> product_default_uom = 47
     */
    productDefaultUom: {
        [key: number]: Product_UnitConversion;
    }; // key is the ProductUnitUsage enum value
    /**
     * @generated from protobuf field: rd.product.Product.ProductCost average_cost_v2 = 48
     */
    averageCostV2?: Product_ProductCost;
    /**
     * @generated from protobuf field: rd.product.Product.ProductCost standard_cost_v2 = 49
     */
    standardCostV2?: Product_ProductCost;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard.Type gift_card_type = 50
     */
    giftCardType: GiftCard_Type; // UNDEFINED if not a gift card product
    /**
     * @generated from protobuf field: bool should_allow_sale_cart_pricing_uom_selection = 51
     */
    shouldAllowSaleCartPricingUomSelection: boolean;
    /**
     * additional_fee_ids supersedes additional_fee_id_string (field 10). During
     * the rollout window both are populated; readers should prefer this list and
     * fall back to a one-element list synthesized from additional_fee_id_string.
     *
     * @generated from protobuf field: repeated string additional_fee_ids = 52
     */
    additionalFeeIds: string[];
    /**
     * when true, this product is excluded from e-commerce listings.
     *
     * @generated from protobuf field: bool is_ecomm_disabled = 53
     */
    isEcommDisabled: boolean;
    /**
     * @generated from protobuf field: rd.product.Product.KitType kit_type = 54
     */
    kitType: Product_KitType; // UNDEFINED if not a kit product
    /**
     * @generated from protobuf field: rd.product.Product.TallyDimension tally_dimension = 55
     */
    tallyDimension: Product_TallyDimension;
    /**
     * @generated from protobuf field: bool is_loyalty_excluded = 56
     */
    isLoyaltyExcluded: boolean;
}
/**
 * @generated from protobuf message rd.product.Product.ProductCost
 */
export interface Product_ProductCost {
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 1
     */
    costV2?: FractionalMoney; // base unit cost
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 2
     */
    uomId?: UUID;
}
/**
 * @generated from protobuf message rd.product.Product.Cost
 */
export interface Product_Cost {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: bool is_default = 3
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 4
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 5
     */
    uomId?: UUID; // unit of measure for the cost
}
/**
 * @generated from protobuf message rd.product.Product.OrderSettings
 */
export interface Product_OrderSettings {
    /**
     * aka "max"; when ordering, order enough qty such that this amount will be
     * in stock
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal target_stock_v2 = 3
     */
    targetStockV2?: Decimal;
    /**
     * aka "min"; order when inventory falls below this amount
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal reorder_point_v2 = 4
     */
    reorderPointV2?: Decimal;
}
/**
 * @generated from protobuf message rd.product.Product.QuantityBreak
 */
export interface Product_QuantityBreak {
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount = 3
     */
    discount?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 4
     */
    quantityV2?: Decimal; // quantity in base unit
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 5
     */
    uomId?: UUID; // unit of measure for the quantity break
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 6
     */
    quantityUom?: Decimal;
}
/**
 * @generated from protobuf message rd.product.Product.UnitConversion
 */
export interface Product_UnitConversion {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 1
     */
    uomId?: UUID; // unit of measure id for the conversion
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal conversion_factor = 2
     */
    conversionFactor?: Decimal; // ratio to base unit factor
}
/**
 * @generated from protobuf enum rd.product.Product.TaxStatus
 */
export enum Product_TaxStatus {
    /**
     * @generated from protobuf enum value: TAX_STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TAX_STATUS_NON_TAXABLE = 1;
     */
    NON_TAXABLE = 1,
    /**
     * @generated from protobuf enum value: TAX_STATUS_SINGLE_USE_TAX_EXEMPT = 2;
     */
    SINGLE_USE_TAX_EXEMPT = 2,
    /**
     * @generated from protobuf enum value: TAX_STATUS_TAXABLE = 3;
     */
    TAXABLE = 3
}
/**
 * @generated from protobuf enum rd.product.Product.ProductUnitUsage
 */
export enum Product_ProductUnitUsage {
    /**
     * @generated from protobuf enum value: PRODUCT_UNIT_USAGE_STOCKING = 0;
     */
    STOCKING = 0,
    /**
     * @generated from protobuf enum value: PRODUCT_UNIT_USAGE_PRICING = 1;
     */
    PRICING = 1,
    /**
     * @generated from protobuf enum value: PRODUCT_UNIT_USAGE_SALE = 2;
     */
    SALE = 2,
    /**
     * @generated from protobuf enum value: PRODUCT_UNIT_USAGE_ORDER = 3;
     */
    ORDER = 3,
    /**
     * @generated from protobuf enum value: PRODUCT_UNIT_USAGE_TRANSFER = 4;
     */
    TRANSFER = 4
}
/**
 * @generated from protobuf enum rd.product.Product.KitType
 */
export enum Product_KitType {
    /**
     * @generated from protobuf enum value: KIT_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: KIT_TYPE_VIRTUAL = 1;
     */
    VIRTUAL = 1
}
/**
 * TallyDimension enables the tally calculator on the sale cart line-item editor.
 *
 * @generated from protobuf enum rd.product.Product.TallyDimension
 */
export enum Product_TallyDimension {
    /**
     * @generated from protobuf enum value: TALLY_DIMENSION_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * quantity x length
     *
     * @generated from protobuf enum value: TALLY_DIMENSION_LENGTH = 1;
     */
    LENGTH = 1,
    /**
     * quantity x (length + width)
     *
     * @generated from protobuf enum value: TALLY_DIMENSION_UNIFIED_LENGTH = 2;
     */
    UNIFIED_LENGTH = 2,
    /**
     * quantity x length x width
     *
     * @generated from protobuf enum value: TALLY_DIMENSION_AREA = 3;
     */
    AREA = 3
}
/**
 * ProductLog represents a change of a Product.
 *
 * @generated from protobuf message rd.product.ProductLog
 */
export interface ProductLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.product.Product product = 4
     */
    product?: Product;
}
/**
 * IdentifierMapping stores product identifier assignments, one row per
 * identifier. The id is derived from the company id and identifier string.
 *
 * @generated from protobuf message rd.product.IdentifierMapping
 */
export interface IdentifierMapping {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 3
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 4
     */
    identifier: string;
    /**
     * Preset scan configuration: default quantity and UOM when this identifier is scanned.
     * The scan presets are optional fields. The scan_uom_id needs to be validated against the
     * product_id.
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal scan_quantity_v2 = 5
     */
    scanQuantityV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID scan_uom_id = 6
     */
    scanUomId?: UUID;
}
/**
 * StockStatusDelta is used to store changes of stock status
 *
 * @generated from protobuf message rd.product.StockStatusDelta
 */
export interface StockStatusDelta {
    /**
     * @generated from protobuf field: map<int32, int32> status_delta = 1
     */
    statusDelta: {
        [key: number]: number;
    }; // key is used to indicate an inventory status, and value is
}
/**
 * Kit is the component configuration for a kit product.
 *
 * @generated from protobuf message rd.product.Kit
 */
export interface Kit {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // same as the product id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID; // required
    /**
     * @generated from protobuf field: repeated rd.product.Kit.Component components = 3
     */
    components: Kit_Component[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 6
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 7
     */
    updatedBy?: User;
}
/**
 * @generated from protobuf message rd.product.Kit.Component
 */
export interface Kit_Component {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 2
     */
    uomId?: UUID; // nil = base unit
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 3
     */
    quantityUom?: Decimal; // quantity in uom_id units
}
/**
 * @generated from protobuf message rd.product.Inventories
 */
export interface Inventories {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // Product ID
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 5
     */
    companyId?: UUID;
    /**
     * on_order_inventories_by_location_id, and committed_inventories_by_location_id
     *
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> on_hand_inventories_by_location_id_v2 = 9
     */
    onHandInventoriesByLocationIdV2: {
        [key: string]: Decimal;
    }; // inventory available for sale
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> on_order_inventories_by_location_id_v2 = 10
     */
    onOrderInventoriesByLocationIdV2: {
        [key: string]: Decimal;
    }; // inventory expected to be received
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> committed_inventories_by_location_id_v2 = 11
     */
    committedInventoriesByLocationIdV2: {
        [key: string]: Decimal;
    }; // inventory designated to leave
}
/**
 * InventoryLog represents changes to a Product's Inventory.
 *
 * @generated from protobuf message rd.product.InventoriesLog
 */
export interface InventoriesLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 4
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 5
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID transfer_id = 6
     */
    transferId?: UUID;
    /**
     * @generated from protobuf field: rd.product.Inventories inventories = 7
     */
    inventories?: Inventories;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_id = 8
     */
    inventoryCountId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 9
     */
    orderShipmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 10
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID ledger_entry_id = 11
     */
    ledgerEntryId?: UUID;
}
/**
 * ProductLabel represents the price label of a product at a given location.
 *
 * @generated from protobuf message rd.product.ProductLabel
 */
export interface ProductLabel {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 4
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 5
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp price_updated_at = 6
     */
    priceUpdatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_printed_at = 7
     */
    lastPrintedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money last_printed_price = 8
     */
    lastPrintedPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 9
     */
    companyId?: UUID;
}
/**
 * LabelDesign stores a company-level custom label template and field settings.
 *
 * @generated from protobuf message rd.product.LabelDesign
 */
export interface LabelDesign {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 4
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string name = 7
     */
    name: string;
    /**
     * @generated from protobuf field: float label_width = 8
     */
    labelWidth: number;
    /**
     * @generated from protobuf field: float label_height = 9
     */
    labelHeight: number;
    /**
     * @generated from protobuf field: repeated rd.product.LabelDesign.FieldConfig fields = 10
     */
    fields: LabelDesign_FieldConfig[];
}
/**
 * @generated from protobuf message rd.product.LabelDesign.FieldConfig
 */
export interface LabelDesign_FieldConfig {
    /**
     * @generated from protobuf field: rd.product.LabelDesign.FieldConfig.LabelDesignFieldType field_type = 1
     */
    fieldType: LabelDesign_FieldConfig_LabelDesignFieldType;
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: float position_x = 3
     */
    positionX: number;
    /**
     * @generated from protobuf field: float position_y = 4
     */
    positionY: number;
    /**
     * @generated from protobuf field: int32 font_size = 5
     */
    fontSize: number;
    /**
     * @generated from protobuf field: bool is_bold = 6
     */
    isBold: boolean;
    /**
     * @generated from protobuf field: string font_family = 7
     */
    fontFamily: string;
    /**
     * @generated from protobuf field: bool include_symbol = 8
     */
    includeSymbol: boolean;
    /**
     * @generated from protobuf field: int32 barcode_width = 9
     */
    barcodeWidth: number;
    /**
     * @generated from protobuf field: int32 barcode_height = 10
     */
    barcodeHeight: number;
    /**
     * @generated from protobuf field: string date_format = 11
     */
    dateFormat: string;
    /**
     * @generated from protobuf field: string text = 12
     */
    text: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 13
     */
    vendorId?: UUID; // optional field for vendorSKU type
}
/**
 * LabelDesignFieldType identifies a configurable field in custom labels.
 *
 * @generated from protobuf enum rd.product.LabelDesign.FieldConfig.LabelDesignFieldType
 */
export enum LabelDesign_FieldConfig_LabelDesignFieldType {
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_PRICE = 2;
     */
    PRICE = 2,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_PRIMARY_IDENTIFIER = 3;
     */
    PRIMARY_IDENTIFIER = 3,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_UPC = 4;
     */
    UPC = 4,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_VENDOR_NAME = 5;
     */
    VENDOR_NAME = 5,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_UNIT_OF_MEASURE = 6;
     */
    UNIT_OF_MEASURE = 6,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_DATE = 7;
     */
    DATE = 7,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_STORE_NAME = 8;
     */
    STORE_NAME = 8,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_STATIC_FIELD = 9;
     */
    STATIC_FIELD = 9,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_CASE_QUANTITY = 10;
     */
    CASE_QUANTITY = 10,
    /**
     * @generated from protobuf enum value: LABEL_DESIGN_FIELD_TYPE_VENDOR_SKU = 11;
     */
    VENDOR_SKU = 11
}
/**
 * InventoryCount is a record of an inventory count.
 *
 * @generated from protobuf message rd.product.InventoryCount
 */
export interface InventoryCount {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 4
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: repeated rd.product.InventoryCount.UpdateHistory update_history = 6
     */
    updateHistory: InventoryCount_UpdateHistory[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 7
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 8
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string name = 9
     */
    name: string;
    /**
     * @generated from protobuf field: rd.product.InventoryCount.Status status = 10
     */
    status: InventoryCount_Status;
    /**
     * @generated from protobuf field: rd.user.User accepted_by = 11
     */
    acceptedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User voided_by = 12
     */
    voidedBy?: User;
    /**
     * @generated from protobuf field: string notes = 13
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.product.InventoryCount.Type type = 14
     */
    type: InventoryCount_Type;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp accepted_at = 15
     */
    acceptedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 16
     */
    voidedAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.product.InventoryCount.UpdateHistory
 */
export interface InventoryCount_UpdateHistory {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 1
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 2
     */
    updatedBy?: User;
}
/**
 * @generated from protobuf enum rd.product.InventoryCount.Status
 */
export enum InventoryCount_Status {
    /**
     * @generated from protobuf enum value: UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: DRAFT = 1;
     */
    DRAFT = 1,
    /**
     * @generated from protobuf enum value: ACCEPTED = 2;
     */
    ACCEPTED = 2,
    /**
     * @generated from protobuf enum value: VOIDED = 3;
     */
    VOIDED = 3
}
/**
 * @generated from protobuf enum rd.product.InventoryCount.Type
 */
export enum InventoryCount_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_FULL = 1;
     */
    FULL = 1,
    /**
     * @generated from protobuf enum value: TYPE_CYCLE = 2;
     */
    CYCLE = 2
}
/**
 * InventoryCountLog is a record of a change to an inventory count.
 *
 * @generated from protobuf message rd.product.InventoryCountLog
 */
export interface InventoryCountLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.product.InventoryCount inventory_count = 4
     */
    inventoryCount?: InventoryCount;
}
/**
 * Inventory Count Products Table
 *
 * @generated from protobuf message rd.product.InventoryCountProduct
 */
export interface InventoryCountProduct {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // Product ID Xor Inventory Count ID
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 4
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_id = 6
     */
    inventoryCountId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 7
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.product.InventoryCountProduct.Status status = 9
     */
    status: InventoryCountProduct_Status;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 10
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 11
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal variance_v2 = 14
     */
    varianceV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal finalized_count_v2 = 15
     */
    finalizedCountV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney finalized_cost = 16
     */
    finalizedCost?: FractionalMoney;
}
/**
 * @generated from protobuf enum rd.product.InventoryCountProduct.Status
 */
export enum InventoryCountProduct_Status {
    /**
     * @generated from protobuf enum value: UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: UNCOUNTED = 1;
     */
    UNCOUNTED = 1,
    /**
     * @generated from protobuf enum value: COUNTED = 2;
     */
    COUNTED = 2,
    /**
     * @generated from protobuf enum value: REMOVED = 3;
     */
    REMOVED = 3,
    /**
     * @generated from protobuf enum value: FINALIZED = 4;
     */
    FINALIZED = 4
}
/**
 * VendorSKU represents a vendor's stock keeping unit (SKU) for a product.
 * Products have at most one SKU per vendor, and SKUs are unique per vendor.
 *
 * @generated from protobuf message rd.product.VendorSKU
 */
export interface VendorSKU {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 5
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 6
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string sku = 7
     */
    sku: string;
}
/**
 * CustomPrintSettings holds page dimensions and margins for custom label printing.
 *
 * @generated from protobuf message rd.product.CustomPrintSettings
 */
export interface CustomPrintSettings {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal paper_width = 1
     */
    paperWidth?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal paper_height = 2
     */
    paperHeight?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_top = 3
     */
    marginTop?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_bottom = 4
     */
    marginBottom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_left = 5
     */
    marginLeft?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal margin_right = 6
     */
    marginRight?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal horizontal_gap = 7
     */
    horizontalGap?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal vertical_gap = 8
     */
    verticalGap?: Decimal;
}
/**
 * UpdateProductVendorSKUsError represents
 *
 * @generated from protobuf message rd.product.UpdateProductVendorSKUsError
 */
export interface UpdateProductVendorSKUsError {
    /**
     * @generated from protobuf field: rd.product.UpdateProductVendorSKUsError.Conflict conflict = 1
     */
    conflict?: UpdateProductVendorSKUsError_Conflict;
}
/**
 * @generated from protobuf message rd.product.UpdateProductVendorSKUsError.Conflict
 */
export interface UpdateProductVendorSKUsError_Conflict {
    /**
     * @generated from protobuf field: rd.product.VendorSKU vendor_sku = 1
     */
    vendorSku?: VendorSKU;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.product.Product product = 3
     */
    product?: Product;
}
/**
 * @generated from protobuf enum rd.product.StockStatus
 */
export enum StockStatus {
    /**
     * inventory available for sale
     *
     * @generated from protobuf enum value: STATUS_ON_HAND = 0;
     */
    STATUS_ON_HAND = 0,
    /**
     * inventory expected to be received
     *
     * @generated from protobuf enum value: STATUS_ON_ORDER = 1;
     */
    STATUS_ON_ORDER = 1,
    /**
     * inventory designated to leave
     *
     * @generated from protobuf enum value: STATUS_COMMITTED = 2;
     */
    STATUS_COMMITTED = 2
}
/**
 * LabelTemplate represents the different types of label templates available for printing product
 * labels. Each is a specific branded template that has a specific layout and dimensions.
 *
 * @generated from protobuf enum rd.product.LabelTemplate
 */
export enum LabelTemplate {
    /**
     * @generated from protobuf enum value: LABEL_TEMPLATE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * 1" x 2 5/8" labels (full sheet)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_AVERY_5160 = 1;
     */
    AVERY_5160 = 1,
    /**
     * 1" x 2 1/8" labels (roll)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_DYMO_30336 = 2;
     */
    DYMO_30336 = 2,
    /**
     * 1.25" x 1.93" labels (full sheet)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_CENTURION_UNG4 = 3;
     */
    CENTURION_UNG4 = 3,
    /**
     * 1.25" x 2" labels (full sheet)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_ULINE_S20247 = 4;
     */
    ULINE_S20247 = 4,
    /**
     * 1.125" x 2" labels (roll)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_CENTURION_CSGENYRR = 5;
     */
    CENTURION_CSGENYRR = 5,
    /**
     * 1.25" x 2.325" labels (roll)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_CENTURION_40030 = 6;
     */
    CENTURION_40030 = 6,
    /**
     * 1" x 2" labels (full sheet, 3/8" yellow bar)
     *
     * @generated from protobuf enum value: LABEL_TEMPLATE_YELLOW_BAR_1X2 = 7;
     */
    YELLOW_BAR_1X2 = 7
}
/**
 * MobileLabelTemplate represents the different types of label templates available for printing
 * product labels on mobile printers. Each is a specific branded template that has a specific layout
 * and dimensions.
 *
 * @generated from protobuf enum rd.product.MobileLabelTemplate
 */
export enum MobileLabelTemplate {
    /**
     * @generated from protobuf enum value: MOBILE_LABEL_TEMPLATE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: MOBILE_LABEL_TEMPLATE_CENTURION_ZTV1A = 1;
     */
    CENTURION_ZTV1A = 1,
    /**
     * @generated from protobuf enum value: MOBILE_LABEL_TEMPLATE_ULINE_S13026 = 2;
     */
    ULINE_S13026 = 2,
    /**
     * @generated from protobuf enum value: MOBILE_LABEL_TEMPLATE_ULINE_S17071 = 3;
     */
    ULINE_S17071 = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Product$Type extends MessageType<Product> {
    constructor() {
        super("rd.product.Product", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 6, name: "updated_by", kind: "message", T: () => User },
            { no: 8, name: "matched_cost_product_id", kind: "message", T: () => UUID },
            { no: 11, name: "identifiers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "is_commissionable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "is_tintable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "costs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product_Cost },
            { no: 22, name: "order_settings_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product_OrderSettings } },
            { no: 24, name: "bin_locations_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 25, name: "quantity_breaks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product_QuantityBreak },
            { no: 28, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "tax_status", kind: "enum", T: () => ["rd.product.Product.TaxStatus", Product_TaxStatus, "TAX_STATUS_"] },
            { no: 30, name: "department_id", kind: "message", T: () => UUID },
            { no: 31, name: "class_id", kind: "message", T: () => UUID },
            { no: 32, name: "fineline_id", kind: "message", T: () => UUID },
            { no: 33, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "sales_reminder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 36, name: "template_sale_product_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "template_order_product_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "restock_fee_rate", kind: "message", T: () => Decimal },
            { no: 41, name: "sale_form_id", kind: "message", T: () => UUID },
            { no: 42, name: "is_special_orderable_v2", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 43, name: "case_quantity_v2", kind: "message", T: () => Decimal },
            { no: 44, name: "allow_decimal_quantities", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 45, name: "should_not_nest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 46, name: "unit_conversions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product_UnitConversion },
            { no: 47, name: "product_default_uom", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => Product_UnitConversion } },
            { no: 48, name: "average_cost_v2", kind: "message", T: () => Product_ProductCost },
            { no: 49, name: "standard_cost_v2", kind: "message", T: () => Product_ProductCost },
            { no: 50, name: "gift_card_type", kind: "enum", T: () => ["rd.giftcard.GiftCard.Type", GiftCard_Type, "TYPE_"] },
            { no: 51, name: "should_allow_sale_cart_pricing_uom_selection", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 52, name: "additional_fee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 53, name: "is_ecomm_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 54, name: "kit_type", kind: "enum", T: () => ["rd.product.Product.KitType", Product_KitType, "KIT_TYPE_"] },
            { no: 55, name: "tally_dimension", kind: "enum", T: () => ["rd.product.Product.TallyDimension", Product_TallyDimension, "TALLY_DIMENSION_"] },
            { no: 56, name: "is_loyalty_excluded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Product>): Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifiers = [];
        message.name = "";
        message.isCommissionable = false;
        message.isTintable = false;
        message.isActive = false;
        message.costs = [];
        message.orderSettingsByLocationId = {};
        message.binLocationsByLocationId = {};
        message.quantityBreaks = [];
        message.isNonStock = false;
        message.taxStatus = 0;
        message.notes = "";
        message.salesReminder = "";
        message.tagIds = [];
        message.templateSaleProductNotes = "";
        message.templateOrderProductNotes = "";
        message.isSpecialOrderableV2 = false;
        message.allowDecimalQuantities = false;
        message.shouldNotNest = false;
        message.unitConversions = [];
        message.productDefaultUom = {};
        message.giftCardType = 0;
        message.shouldAllowSaleCartPricingUomSelection = false;
        message.additionalFeeIds = [];
        message.isEcommDisabled = false;
        message.kitType = 0;
        message.tallyDimension = 0;
        message.isLoyaltyExcluded = false;
        if (value !== undefined)
            reflectionMergePartial<Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product): Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 6:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID matched_cost_product_id */ 8:
                    message.matchedCostProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.matchedCostProductId);
                    break;
                case /* repeated string identifiers */ 11:
                    message.identifiers.push(reader.string());
                    break;
                case /* string name */ 12:
                    message.name = reader.string();
                    break;
                case /* bool is_commissionable */ 14:
                    message.isCommissionable = reader.bool();
                    break;
                case /* bool is_tintable */ 15:
                    message.isTintable = reader.bool();
                    break;
                case /* bool is_active */ 16:
                    message.isActive = reader.bool();
                    break;
                case /* repeated rd.product.Product.Cost costs */ 18:
                    message.costs.push(Product_Cost.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.product.Product.OrderSettings> order_settings_by_location_id */ 22:
                    this.binaryReadMap22(message.orderSettingsByLocationId, reader, options);
                    break;
                case /* map<string, string> bin_locations_by_location_id */ 24:
                    this.binaryReadMap24(message.binLocationsByLocationId, reader, options);
                    break;
                case /* repeated rd.product.Product.QuantityBreak quantity_breaks */ 25:
                    message.quantityBreaks.push(Product_QuantityBreak.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_non_stock */ 28:
                    message.isNonStock = reader.bool();
                    break;
                case /* rd.product.Product.TaxStatus tax_status */ 29:
                    message.taxStatus = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID department_id */ 30:
                    message.departmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.departmentId);
                    break;
                case /* rd.proto.uuid.UUID class_id */ 31:
                    message.classId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.classId);
                    break;
                case /* rd.proto.uuid.UUID fineline_id */ 32:
                    message.finelineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.finelineId);
                    break;
                case /* string notes */ 33:
                    message.notes = reader.string();
                    break;
                case /* string sales_reminder */ 34:
                    message.salesReminder = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 35:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string template_sale_product_notes */ 36:
                    message.templateSaleProductNotes = reader.string();
                    break;
                case /* string template_order_product_notes */ 37:
                    message.templateOrderProductNotes = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal restock_fee_rate */ 40:
                    message.restockFeeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.restockFeeRate);
                    break;
                case /* rd.proto.uuid.UUID sale_form_id */ 41:
                    message.saleFormId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleFormId);
                    break;
                case /* bool is_special_orderable_v2 */ 42:
                    message.isSpecialOrderableV2 = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal case_quantity_v2 */ 43:
                    message.caseQuantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.caseQuantityV2);
                    break;
                case /* bool allow_decimal_quantities */ 44:
                    message.allowDecimalQuantities = reader.bool();
                    break;
                case /* bool should_not_nest */ 45:
                    message.shouldNotNest = reader.bool();
                    break;
                case /* repeated rd.product.Product.UnitConversion unit_conversions */ 46:
                    message.unitConversions.push(Product_UnitConversion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<int32, rd.product.Product.UnitConversion> product_default_uom */ 47:
                    this.binaryReadMap47(message.productDefaultUom, reader, options);
                    break;
                case /* rd.product.Product.ProductCost average_cost_v2 */ 48:
                    message.averageCostV2 = Product_ProductCost.internalBinaryRead(reader, reader.uint32(), options, message.averageCostV2);
                    break;
                case /* rd.product.Product.ProductCost standard_cost_v2 */ 49:
                    message.standardCostV2 = Product_ProductCost.internalBinaryRead(reader, reader.uint32(), options, message.standardCostV2);
                    break;
                case /* rd.giftcard.GiftCard.Type gift_card_type */ 50:
                    message.giftCardType = reader.int32();
                    break;
                case /* bool should_allow_sale_cart_pricing_uom_selection */ 51:
                    message.shouldAllowSaleCartPricingUomSelection = reader.bool();
                    break;
                case /* repeated string additional_fee_ids */ 52:
                    message.additionalFeeIds.push(reader.string());
                    break;
                case /* bool is_ecomm_disabled */ 53:
                    message.isEcommDisabled = reader.bool();
                    break;
                case /* rd.product.Product.KitType kit_type */ 54:
                    message.kitType = reader.int32();
                    break;
                case /* rd.product.Product.TallyDimension tally_dimension */ 55:
                    message.tallyDimension = reader.int32();
                    break;
                case /* bool is_loyalty_excluded */ 56:
                    message.isLoyaltyExcluded = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap22(map: Product["orderSettingsByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Product["orderSettingsByLocationId"] | undefined, val: Product["orderSettingsByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product_OrderSettings.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.Product.order_settings_by_location_id");
            }
        }
        map[key ?? ""] = val ?? Product_OrderSettings.create();
    }
    private binaryReadMap24(map: Product["binLocationsByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Product["binLocationsByLocationId"] | undefined, val: Product["binLocationsByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.Product.bin_locations_by_location_id");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap47(map: Product["productDefaultUom"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Product["productDefaultUom"] | undefined, val: Product["productDefaultUom"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = Product_UnitConversion.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.Product.product_default_uom");
            }
        }
        map[key ?? 0] = val ?? Product_UnitConversion.create();
    }
    internalBinaryWrite(message: Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 6; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID matched_cost_product_id = 8; */
        if (message.matchedCostProductId)
            UUID.internalBinaryWrite(message.matchedCostProductId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string identifiers = 11; */
        for (let i = 0; i < message.identifiers.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.identifiers[i]);
        /* string name = 12; */
        if (message.name !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.name);
        /* bool is_commissionable = 14; */
        if (message.isCommissionable !== false)
            writer.tag(14, WireType.Varint).bool(message.isCommissionable);
        /* bool is_tintable = 15; */
        if (message.isTintable !== false)
            writer.tag(15, WireType.Varint).bool(message.isTintable);
        /* bool is_active = 16; */
        if (message.isActive !== false)
            writer.tag(16, WireType.Varint).bool(message.isActive);
        /* repeated rd.product.Product.Cost costs = 18; */
        for (let i = 0; i < message.costs.length; i++)
            Product_Cost.internalBinaryWrite(message.costs[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product.OrderSettings> order_settings_by_location_id = 22; */
        for (let k of globalThis.Object.keys(message.orderSettingsByLocationId)) {
            writer.tag(22, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product_OrderSettings.internalBinaryWrite(message.orderSettingsByLocationId[k], writer, options);
            writer.join().join();
        }
        /* map<string, string> bin_locations_by_location_id = 24; */
        for (let k of globalThis.Object.keys(message.binLocationsByLocationId))
            writer.tag(24, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.binLocationsByLocationId[k]).join();
        /* repeated rd.product.Product.QuantityBreak quantity_breaks = 25; */
        for (let i = 0; i < message.quantityBreaks.length; i++)
            Product_QuantityBreak.internalBinaryWrite(message.quantityBreaks[i], writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* bool is_non_stock = 28; */
        if (message.isNonStock !== false)
            writer.tag(28, WireType.Varint).bool(message.isNonStock);
        /* rd.product.Product.TaxStatus tax_status = 29; */
        if (message.taxStatus !== 0)
            writer.tag(29, WireType.Varint).int32(message.taxStatus);
        /* rd.proto.uuid.UUID department_id = 30; */
        if (message.departmentId)
            UUID.internalBinaryWrite(message.departmentId, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID class_id = 31; */
        if (message.classId)
            UUID.internalBinaryWrite(message.classId, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fineline_id = 32; */
        if (message.finelineId)
            UUID.internalBinaryWrite(message.finelineId, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 33; */
        if (message.notes !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.notes);
        /* string sales_reminder = 34; */
        if (message.salesReminder !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.salesReminder);
        /* repeated rd.proto.uuid.UUID tag_ids = 35; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* string template_sale_product_notes = 36; */
        if (message.templateSaleProductNotes !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.templateSaleProductNotes);
        /* string template_order_product_notes = 37; */
        if (message.templateOrderProductNotes !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.templateOrderProductNotes);
        /* rd.proto.decimal.Decimal restock_fee_rate = 40; */
        if (message.restockFeeRate)
            Decimal.internalBinaryWrite(message.restockFeeRate, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_form_id = 41; */
        if (message.saleFormId)
            UUID.internalBinaryWrite(message.saleFormId, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_orderable_v2 = 42; */
        if (message.isSpecialOrderableV2 !== false)
            writer.tag(42, WireType.Varint).bool(message.isSpecialOrderableV2);
        /* rd.proto.decimal.Decimal case_quantity_v2 = 43; */
        if (message.caseQuantityV2)
            Decimal.internalBinaryWrite(message.caseQuantityV2, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* bool allow_decimal_quantities = 44; */
        if (message.allowDecimalQuantities !== false)
            writer.tag(44, WireType.Varint).bool(message.allowDecimalQuantities);
        /* bool should_not_nest = 45; */
        if (message.shouldNotNest !== false)
            writer.tag(45, WireType.Varint).bool(message.shouldNotNest);
        /* repeated rd.product.Product.UnitConversion unit_conversions = 46; */
        for (let i = 0; i < message.unitConversions.length; i++)
            Product_UnitConversion.internalBinaryWrite(message.unitConversions[i], writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* map<int32, rd.product.Product.UnitConversion> product_default_uom = 47; */
        for (let k of globalThis.Object.keys(message.productDefaultUom)) {
            writer.tag(47, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            Product_UnitConversion.internalBinaryWrite(message.productDefaultUom[k as any], writer, options);
            writer.join().join();
        }
        /* rd.product.Product.ProductCost average_cost_v2 = 48; */
        if (message.averageCostV2)
            Product_ProductCost.internalBinaryWrite(message.averageCostV2, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product.ProductCost standard_cost_v2 = 49; */
        if (message.standardCostV2)
            Product_ProductCost.internalBinaryWrite(message.standardCostV2, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCard.Type gift_card_type = 50; */
        if (message.giftCardType !== 0)
            writer.tag(50, WireType.Varint).int32(message.giftCardType);
        /* bool should_allow_sale_cart_pricing_uom_selection = 51; */
        if (message.shouldAllowSaleCartPricingUomSelection !== false)
            writer.tag(51, WireType.Varint).bool(message.shouldAllowSaleCartPricingUomSelection);
        /* repeated string additional_fee_ids = 52; */
        for (let i = 0; i < message.additionalFeeIds.length; i++)
            writer.tag(52, WireType.LengthDelimited).string(message.additionalFeeIds[i]);
        /* bool is_ecomm_disabled = 53; */
        if (message.isEcommDisabled !== false)
            writer.tag(53, WireType.Varint).bool(message.isEcommDisabled);
        /* rd.product.Product.KitType kit_type = 54; */
        if (message.kitType !== 0)
            writer.tag(54, WireType.Varint).int32(message.kitType);
        /* rd.product.Product.TallyDimension tally_dimension = 55; */
        if (message.tallyDimension !== 0)
            writer.tag(55, WireType.Varint).int32(message.tallyDimension);
        /* bool is_loyalty_excluded = 56; */
        if (message.isLoyaltyExcluded !== false)
            writer.tag(56, WireType.Varint).bool(message.isLoyaltyExcluded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Product
 */
export const Product = new Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_ProductCost$Type extends MessageType<Product_ProductCost> {
    constructor() {
        super("rd.product.Product.ProductCost", [
            { no: 1, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 2, name: "uom_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Product_ProductCost>): Product_ProductCost {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Product_ProductCost>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_ProductCost): Product_ProductCost {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.FractionalMoney cost_v2 */ 1:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 2:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_ProductCost, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.FractionalMoney cost_v2 = 1; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 2; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Product.ProductCost
 */
export const Product_ProductCost = new Product_ProductCost$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_Cost$Type extends MessageType<Product_Cost> {
    constructor() {
        super("rd.product.Product.Cost", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 3, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 5, name: "uom_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Product_Cost>): Product_Cost {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDefault = false;
        if (value !== undefined)
            reflectionMergePartial<Product_Cost>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_Cost): Product_Cost {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* bool is_default */ 3:
                    message.isDefault = reader.bool();
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 4:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 5:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_Cost, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_default = 3; */
        if (message.isDefault !== false)
            writer.tag(3, WireType.Varint).bool(message.isDefault);
        /* rd.proto.money.FractionalMoney cost_v2 = 4; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 5; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Product.Cost
 */
export const Product_Cost = new Product_Cost$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_OrderSettings$Type extends MessageType<Product_OrderSettings> {
    constructor() {
        super("rd.product.Product.OrderSettings", [
            { no: 3, name: "target_stock_v2", kind: "message", T: () => Decimal },
            { no: 4, name: "reorder_point_v2", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Product_OrderSettings>): Product_OrderSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Product_OrderSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_OrderSettings): Product_OrderSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal target_stock_v2 */ 3:
                    message.targetStockV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.targetStockV2);
                    break;
                case /* rd.proto.decimal.Decimal reorder_point_v2 */ 4:
                    message.reorderPointV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.reorderPointV2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_OrderSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal target_stock_v2 = 3; */
        if (message.targetStockV2)
            Decimal.internalBinaryWrite(message.targetStockV2, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal reorder_point_v2 = 4; */
        if (message.reorderPointV2)
            Decimal.internalBinaryWrite(message.reorderPointV2, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Product.OrderSettings
 */
export const Product_OrderSettings = new Product_OrderSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_QuantityBreak$Type extends MessageType<Product_QuantityBreak> {
    constructor() {
        super("rd.product.Product.QuantityBreak", [
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "discount", kind: "message", T: () => Decimal },
            { no: 4, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 5, name: "uom_id", kind: "message", T: () => UUID },
            { no: 6, name: "quantity_uom", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Product_QuantityBreak>): Product_QuantityBreak {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<Product_QuantityBreak>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_QuantityBreak): Product_QuantityBreak {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal discount */ 3:
                    message.discount = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discount);
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 4:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 5:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 6:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_QuantityBreak, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.decimal.Decimal discount = 3; */
        if (message.discount)
            Decimal.internalBinaryWrite(message.discount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_v2 = 4; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 5; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 6; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Product.QuantityBreak
 */
export const Product_QuantityBreak = new Product_QuantityBreak$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_UnitConversion$Type extends MessageType<Product_UnitConversion> {
    constructor() {
        super("rd.product.Product.UnitConversion", [
            { no: 1, name: "uom_id", kind: "message", T: () => UUID },
            { no: 2, name: "conversion_factor", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Product_UnitConversion>): Product_UnitConversion {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Product_UnitConversion>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_UnitConversion): Product_UnitConversion {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID uom_id */ 1:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal conversion_factor */ 2:
                    message.conversionFactor = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.conversionFactor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_UnitConversion, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID uom_id = 1; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal conversion_factor = 2; */
        if (message.conversionFactor)
            Decimal.internalBinaryWrite(message.conversionFactor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Product.UnitConversion
 */
export const Product_UnitConversion = new Product_UnitConversion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductLog$Type extends MessageType<ProductLog> {
    constructor() {
        super("rd.product.ProductLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<ProductLog>): ProductLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProductLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductLog): ProductLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.product.Product product */ 4:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 4; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.ProductLog
 */
export const ProductLog = new ProductLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IdentifierMapping$Type extends MessageType<IdentifierMapping> {
    constructor() {
        super("rd.product.IdentifierMapping", [
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "product_id", kind: "message", T: () => UUID },
            { no: 4, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "scan_quantity_v2", kind: "message", T: () => Decimal },
            { no: 6, name: "scan_uom_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<IdentifierMapping>): IdentifierMapping {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<IdentifierMapping>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IdentifierMapping): IdentifierMapping {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 3:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* string identifier */ 4:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal scan_quantity_v2 */ 5:
                    message.scanQuantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.scanQuantityV2);
                    break;
                case /* rd.proto.uuid.UUID scan_uom_id */ 6:
                    message.scanUomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.scanUomId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IdentifierMapping, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 3; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 4; */
        if (message.identifier !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.decimal.Decimal scan_quantity_v2 = 5; */
        if (message.scanQuantityV2)
            Decimal.internalBinaryWrite(message.scanQuantityV2, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID scan_uom_id = 6; */
        if (message.scanUomId)
            UUID.internalBinaryWrite(message.scanUomId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.IdentifierMapping
 */
export const IdentifierMapping = new IdentifierMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StockStatusDelta$Type extends MessageType<StockStatusDelta> {
    constructor() {
        super("rd.product.StockStatusDelta", [
            { no: 1, name: "status_delta", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } }
        ]);
    }
    create(value?: PartialMessage<StockStatusDelta>): StockStatusDelta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statusDelta = {};
        if (value !== undefined)
            reflectionMergePartial<StockStatusDelta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StockStatusDelta): StockStatusDelta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<int32, int32> status_delta */ 1:
                    this.binaryReadMap1(message.statusDelta, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: StockStatusDelta["statusDelta"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof StockStatusDelta["statusDelta"] | undefined, val: StockStatusDelta["statusDelta"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.StockStatusDelta.status_delta");
            }
        }
        map[key ?? 0] = val ?? 0;
    }
    internalBinaryWrite(message: StockStatusDelta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<int32, int32> status_delta = 1; */
        for (let k of globalThis.Object.keys(message.statusDelta))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.Varint).int32(message.statusDelta[k as any]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.StockStatusDelta
 */
export const StockStatusDelta = new StockStatusDelta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Kit$Type extends MessageType<Kit> {
    constructor() {
        super("rd.product.Kit", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Kit_Component },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "created_by", kind: "message", T: () => User },
            { no: 7, name: "updated_by", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<Kit>): Kit {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.components = [];
        if (value !== undefined)
            reflectionMergePartial<Kit>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Kit): Kit {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* repeated rd.product.Kit.Component components */ 3:
                    message.components.push(Kit_Component.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 6:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 7:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Kit, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.product.Kit.Component components = 3; */
        for (let i = 0; i < message.components.length; i++)
            Kit_Component.internalBinaryWrite(message.components[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 6; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 7; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Kit
 */
export const Kit = new Kit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Kit_Component$Type extends MessageType<Kit_Component> {
    constructor() {
        super("rd.product.Kit.Component", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 2, name: "uom_id", kind: "message", T: () => UUID },
            { no: 3, name: "quantity_uom", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Kit_Component>): Kit_Component {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Kit_Component>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Kit_Component): Kit_Component {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 2:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 3:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Kit_Component, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 2; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 3; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Kit.Component
 */
export const Kit_Component = new Kit_Component$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Inventories$Type extends MessageType<Inventories> {
    constructor() {
        super("rd.product.Inventories", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "company_id", kind: "message", T: () => UUID },
            { no: 9, name: "on_hand_inventories_by_location_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 10, name: "on_order_inventories_by_location_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 11, name: "committed_inventories_by_location_id_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } }
        ]);
    }
    create(value?: PartialMessage<Inventories>): Inventories {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.onHandInventoriesByLocationIdV2 = {};
        message.onOrderInventoriesByLocationIdV2 = {};
        message.committedInventoriesByLocationIdV2 = {};
        if (value !== undefined)
            reflectionMergePartial<Inventories>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Inventories): Inventories {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 5:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> on_hand_inventories_by_location_id_v2 */ 9:
                    this.binaryReadMap9(message.onHandInventoriesByLocationIdV2, reader, options);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> on_order_inventories_by_location_id_v2 */ 10:
                    this.binaryReadMap10(message.onOrderInventoriesByLocationIdV2, reader, options);
                    break;
                case /* map<string, rd.proto.decimal.Decimal> committed_inventories_by_location_id_v2 */ 11:
                    this.binaryReadMap11(message.committedInventoriesByLocationIdV2, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: Inventories["onHandInventoriesByLocationIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Inventories["onHandInventoriesByLocationIdV2"] | undefined, val: Inventories["onHandInventoriesByLocationIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.Inventories.on_hand_inventories_by_location_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap10(map: Inventories["onOrderInventoriesByLocationIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Inventories["onOrderInventoriesByLocationIdV2"] | undefined, val: Inventories["onOrderInventoriesByLocationIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.Inventories.on_order_inventories_by_location_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap11(map: Inventories["committedInventoriesByLocationIdV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Inventories["committedInventoriesByLocationIdV2"] | undefined, val: Inventories["committedInventoriesByLocationIdV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.product.Inventories.committed_inventories_by_location_id_v2");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    internalBinaryWrite(message: Inventories, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 5; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.decimal.Decimal> on_hand_inventories_by_location_id_v2 = 9; */
        for (let k of globalThis.Object.keys(message.onHandInventoriesByLocationIdV2)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.onHandInventoriesByLocationIdV2[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.decimal.Decimal> on_order_inventories_by_location_id_v2 = 10; */
        for (let k of globalThis.Object.keys(message.onOrderInventoriesByLocationIdV2)) {
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.onOrderInventoriesByLocationIdV2[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.decimal.Decimal> committed_inventories_by_location_id_v2 = 11; */
        for (let k of globalThis.Object.keys(message.committedInventoriesByLocationIdV2)) {
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.committedInventoriesByLocationIdV2[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.Inventories
 */
export const Inventories = new Inventories$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoriesLog$Type extends MessageType<InventoriesLog> {
    constructor() {
        super("rd.product.InventoriesLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "sale_id", kind: "message", T: () => UUID },
            { no: 5, name: "order_id", kind: "message", T: () => UUID },
            { no: 6, name: "transfer_id", kind: "message", T: () => UUID },
            { no: 7, name: "inventories", kind: "message", T: () => Inventories },
            { no: 8, name: "inventory_count_id", kind: "message", T: () => UUID },
            { no: 9, name: "order_shipment_id", kind: "message", T: () => UUID },
            { no: 10, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 11, name: "ledger_entry_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<InventoriesLog>): InventoriesLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<InventoriesLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoriesLog): InventoriesLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 4:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID order_id */ 5:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* rd.proto.uuid.UUID transfer_id */ 6:
                    message.transferId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.transferId);
                    break;
                case /* rd.product.Inventories inventories */ 7:
                    message.inventories = Inventories.internalBinaryRead(reader, reader.uint32(), options, message.inventories);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_id */ 8:
                    message.inventoryCountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountId);
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 9:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 10:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.uuid.UUID ledger_entry_id */ 11:
                    message.ledgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntryId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoriesLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 4; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_id = 5; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID transfer_id = 6; */
        if (message.transferId)
            UUID.internalBinaryWrite(message.transferId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Inventories inventories = 7; */
        if (message.inventories)
            Inventories.internalBinaryWrite(message.inventories, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_id = 8; */
        if (message.inventoryCountId)
            UUID.internalBinaryWrite(message.inventoryCountId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_shipment_id = 9; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 10; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID ledger_entry_id = 11; */
        if (message.ledgerEntryId)
            UUID.internalBinaryWrite(message.ledgerEntryId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.InventoriesLog
 */
export const InventoriesLog = new InventoriesLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductLabel$Type extends MessageType<ProductLabel> {
    constructor() {
        super("rd.product.ProductLabel", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "product_id", kind: "message", T: () => UUID },
            { no: 5, name: "location_id", kind: "message", T: () => UUID },
            { no: 6, name: "price_updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "last_printed_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "last_printed_price", kind: "message", T: () => Money },
            { no: 9, name: "company_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<ProductLabel>): ProductLabel {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProductLabel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductLabel): ProductLabel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 4:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 5:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp price_updated_at */ 6:
                    message.priceUpdatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.priceUpdatedAt);
                    break;
                case /* google.protobuf.Timestamp last_printed_at */ 7:
                    message.lastPrintedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastPrintedAt);
                    break;
                case /* rd.proto.money.Money last_printed_price */ 8:
                    message.lastPrintedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.lastPrintedPrice);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 9:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductLabel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 4; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 5; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp price_updated_at = 6; */
        if (message.priceUpdatedAt)
            Timestamp.internalBinaryWrite(message.priceUpdatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_printed_at = 7; */
        if (message.lastPrintedAt)
            Timestamp.internalBinaryWrite(message.lastPrintedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money last_printed_price = 8; */
        if (message.lastPrintedPrice)
            Money.internalBinaryWrite(message.lastPrintedPrice, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 9; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.ProductLabel
 */
export const ProductLabel = new ProductLabel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LabelDesign$Type extends MessageType<LabelDesign> {
    constructor() {
        super("rd.product.LabelDesign", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "created_by", kind: "message", T: () => User },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "label_width", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "label_height", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LabelDesign_FieldConfig }
        ]);
    }
    create(value?: PartialMessage<LabelDesign>): LabelDesign {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.labelWidth = 0;
        message.labelHeight = 0;
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<LabelDesign>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LabelDesign): LabelDesign {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 4:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                case /* float label_width */ 8:
                    message.labelWidth = reader.float();
                    break;
                case /* float label_height */ 9:
                    message.labelHeight = reader.float();
                    break;
                case /* repeated rd.product.LabelDesign.FieldConfig fields */ 10:
                    message.fields.push(LabelDesign_FieldConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LabelDesign, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 4; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        /* float label_width = 8; */
        if (message.labelWidth !== 0)
            writer.tag(8, WireType.Bit32).float(message.labelWidth);
        /* float label_height = 9; */
        if (message.labelHeight !== 0)
            writer.tag(9, WireType.Bit32).float(message.labelHeight);
        /* repeated rd.product.LabelDesign.FieldConfig fields = 10; */
        for (let i = 0; i < message.fields.length; i++)
            LabelDesign_FieldConfig.internalBinaryWrite(message.fields[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.LabelDesign
 */
export const LabelDesign = new LabelDesign$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LabelDesign_FieldConfig$Type extends MessageType<LabelDesign_FieldConfig> {
    constructor() {
        super("rd.product.LabelDesign.FieldConfig", [
            { no: 1, name: "field_type", kind: "enum", T: () => ["rd.product.LabelDesign.FieldConfig.LabelDesignFieldType", LabelDesign_FieldConfig_LabelDesignFieldType, "LABEL_DESIGN_FIELD_TYPE_"] },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "position_x", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "position_y", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "font_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "is_bold", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "font_family", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "include_symbol", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "barcode_width", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "barcode_height", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "date_format", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "vendor_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<LabelDesign_FieldConfig>): LabelDesign_FieldConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fieldType = 0;
        message.enabled = false;
        message.positionX = 0;
        message.positionY = 0;
        message.fontSize = 0;
        message.isBold = false;
        message.fontFamily = "";
        message.includeSymbol = false;
        message.barcodeWidth = 0;
        message.barcodeHeight = 0;
        message.dateFormat = "";
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial<LabelDesign_FieldConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LabelDesign_FieldConfig): LabelDesign_FieldConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.LabelDesign.FieldConfig.LabelDesignFieldType field_type */ 1:
                    message.fieldType = reader.int32();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                case /* float position_x */ 3:
                    message.positionX = reader.float();
                    break;
                case /* float position_y */ 4:
                    message.positionY = reader.float();
                    break;
                case /* int32 font_size */ 5:
                    message.fontSize = reader.int32();
                    break;
                case /* bool is_bold */ 6:
                    message.isBold = reader.bool();
                    break;
                case /* string font_family */ 7:
                    message.fontFamily = reader.string();
                    break;
                case /* bool include_symbol */ 8:
                    message.includeSymbol = reader.bool();
                    break;
                case /* int32 barcode_width */ 9:
                    message.barcodeWidth = reader.int32();
                    break;
                case /* int32 barcode_height */ 10:
                    message.barcodeHeight = reader.int32();
                    break;
                case /* string date_format */ 11:
                    message.dateFormat = reader.string();
                    break;
                case /* string text */ 12:
                    message.text = reader.string();
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 13:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LabelDesign_FieldConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.LabelDesign.FieldConfig.LabelDesignFieldType field_type = 1; */
        if (message.fieldType !== 0)
            writer.tag(1, WireType.Varint).int32(message.fieldType);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        /* float position_x = 3; */
        if (message.positionX !== 0)
            writer.tag(3, WireType.Bit32).float(message.positionX);
        /* float position_y = 4; */
        if (message.positionY !== 0)
            writer.tag(4, WireType.Bit32).float(message.positionY);
        /* int32 font_size = 5; */
        if (message.fontSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.fontSize);
        /* bool is_bold = 6; */
        if (message.isBold !== false)
            writer.tag(6, WireType.Varint).bool(message.isBold);
        /* string font_family = 7; */
        if (message.fontFamily !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.fontFamily);
        /* bool include_symbol = 8; */
        if (message.includeSymbol !== false)
            writer.tag(8, WireType.Varint).bool(message.includeSymbol);
        /* int32 barcode_width = 9; */
        if (message.barcodeWidth !== 0)
            writer.tag(9, WireType.Varint).int32(message.barcodeWidth);
        /* int32 barcode_height = 10; */
        if (message.barcodeHeight !== 0)
            writer.tag(10, WireType.Varint).int32(message.barcodeHeight);
        /* string date_format = 11; */
        if (message.dateFormat !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dateFormat);
        /* string text = 12; */
        if (message.text !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.text);
        /* rd.proto.uuid.UUID vendor_id = 13; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.LabelDesign.FieldConfig
 */
export const LabelDesign_FieldConfig = new LabelDesign_FieldConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryCount$Type extends MessageType<InventoryCount> {
    constructor() {
        super("rd.product.InventoryCount", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "created_by", kind: "message", T: () => User },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "update_history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InventoryCount_UpdateHistory },
            { no: 7, name: "location_id", kind: "message", T: () => UUID },
            { no: 8, name: "company_id", kind: "message", T: () => UUID },
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "status", kind: "enum", T: () => ["rd.product.InventoryCount.Status", InventoryCount_Status] },
            { no: 11, name: "accepted_by", kind: "message", T: () => User },
            { no: 12, name: "voided_by", kind: "message", T: () => User },
            { no: 13, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "type", kind: "enum", T: () => ["rd.product.InventoryCount.Type", InventoryCount_Type, "TYPE_"] },
            { no: 15, name: "accepted_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "voided_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<InventoryCount>): InventoryCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateHistory = [];
        message.name = "";
        message.status = 0;
        message.notes = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<InventoryCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryCount): InventoryCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 4:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* repeated rd.product.InventoryCount.UpdateHistory update_history */ 6:
                    message.updateHistory.push(InventoryCount_UpdateHistory.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID location_id */ 7:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 8:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string name */ 9:
                    message.name = reader.string();
                    break;
                case /* rd.product.InventoryCount.Status status */ 10:
                    message.status = reader.int32();
                    break;
                case /* rd.user.User accepted_by */ 11:
                    message.acceptedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.acceptedBy);
                    break;
                case /* rd.user.User voided_by */ 12:
                    message.voidedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.voidedBy);
                    break;
                case /* string notes */ 13:
                    message.notes = reader.string();
                    break;
                case /* rd.product.InventoryCount.Type type */ 14:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Timestamp accepted_at */ 15:
                    message.acceptedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.acceptedAt);
                    break;
                case /* google.protobuf.Timestamp voided_at */ 16:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 4; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.product.InventoryCount.UpdateHistory update_history = 6; */
        for (let i = 0; i < message.updateHistory.length; i++)
            InventoryCount_UpdateHistory.internalBinaryWrite(message.updateHistory[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 7; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 8; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string name = 9; */
        if (message.name !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.name);
        /* rd.product.InventoryCount.Status status = 10; */
        if (message.status !== 0)
            writer.tag(10, WireType.Varint).int32(message.status);
        /* rd.user.User accepted_by = 11; */
        if (message.acceptedBy)
            User.internalBinaryWrite(message.acceptedBy, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User voided_by = 12; */
        if (message.voidedBy)
            User.internalBinaryWrite(message.voidedBy, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 13; */
        if (message.notes !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.notes);
        /* rd.product.InventoryCount.Type type = 14; */
        if (message.type !== 0)
            writer.tag(14, WireType.Varint).int32(message.type);
        /* google.protobuf.Timestamp accepted_at = 15; */
        if (message.acceptedAt)
            Timestamp.internalBinaryWrite(message.acceptedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp voided_at = 16; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.InventoryCount
 */
export const InventoryCount = new InventoryCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryCount_UpdateHistory$Type extends MessageType<InventoryCount_UpdateHistory> {
    constructor() {
        super("rd.product.InventoryCount.UpdateHistory", [
            { no: 1, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "updated_by", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<InventoryCount_UpdateHistory>): InventoryCount_UpdateHistory {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<InventoryCount_UpdateHistory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryCount_UpdateHistory): InventoryCount_UpdateHistory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp updated_at */ 1:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 2:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryCount_UpdateHistory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp updated_at = 1; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 2; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.InventoryCount.UpdateHistory
 */
export const InventoryCount_UpdateHistory = new InventoryCount_UpdateHistory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryCountLog$Type extends MessageType<InventoryCountLog> {
    constructor() {
        super("rd.product.InventoryCountLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "inventory_count", kind: "message", T: () => InventoryCount }
        ]);
    }
    create(value?: PartialMessage<InventoryCountLog>): InventoryCountLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<InventoryCountLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryCountLog): InventoryCountLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.product.InventoryCount inventory_count */ 4:
                    message.inventoryCount = InventoryCount.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryCountLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.InventoryCount inventory_count = 4; */
        if (message.inventoryCount)
            InventoryCount.internalBinaryWrite(message.inventoryCount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.InventoryCountLog
 */
export const InventoryCountLog = new InventoryCountLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InventoryCountProduct$Type extends MessageType<InventoryCountProduct> {
    constructor() {
        super("rd.product.InventoryCountProduct", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "created_by", kind: "message", T: () => User },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "inventory_count_id", kind: "message", T: () => UUID },
            { no: 7, name: "product_id", kind: "message", T: () => UUID },
            { no: 9, name: "status", kind: "enum", T: () => ["rd.product.InventoryCountProduct.Status", InventoryCountProduct_Status] },
            { no: 10, name: "company_id", kind: "message", T: () => UUID },
            { no: 11, name: "location_id", kind: "message", T: () => UUID },
            { no: 14, name: "variance_v2", kind: "message", T: () => Decimal },
            { no: 15, name: "finalized_count_v2", kind: "message", T: () => Decimal },
            { no: 16, name: "finalized_cost", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<InventoryCountProduct>): InventoryCountProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<InventoryCountProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InventoryCountProduct): InventoryCountProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 4:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_id */ 6:
                    message.inventoryCountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 7:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.product.InventoryCountProduct.Status status */ 9:
                    message.status = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 10:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 11:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.decimal.Decimal variance_v2 */ 14:
                    message.varianceV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.varianceV2);
                    break;
                case /* rd.proto.decimal.Decimal finalized_count_v2 */ 15:
                    message.finalizedCountV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.finalizedCountV2);
                    break;
                case /* rd.proto.money.FractionalMoney finalized_cost */ 16:
                    message.finalizedCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.finalizedCost);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InventoryCountProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 4; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_id = 6; */
        if (message.inventoryCountId)
            UUID.internalBinaryWrite(message.inventoryCountId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 7; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.InventoryCountProduct.Status status = 9; */
        if (message.status !== 0)
            writer.tag(9, WireType.Varint).int32(message.status);
        /* rd.proto.uuid.UUID company_id = 10; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 11; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal variance_v2 = 14; */
        if (message.varianceV2)
            Decimal.internalBinaryWrite(message.varianceV2, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal finalized_count_v2 = 15; */
        if (message.finalizedCountV2)
            Decimal.internalBinaryWrite(message.finalizedCountV2, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney finalized_cost = 16; */
        if (message.finalizedCost)
            FractionalMoney.internalBinaryWrite(message.finalizedCost, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.InventoryCountProduct
 */
export const InventoryCountProduct = new InventoryCountProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorSKU$Type extends MessageType<VendorSKU> {
    constructor() {
        super("rd.product.VendorSKU", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "product_id", kind: "message", T: () => UUID },
            { no: 6, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 7, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VendorSKU>): VendorSKU {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sku = "";
        if (value !== undefined)
            reflectionMergePartial<VendorSKU>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorSKU): VendorSKU {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 5:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 6:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string sku */ 7:
                    message.sku = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorSKU, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 5; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 6; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string sku = 7; */
        if (message.sku !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.sku);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.VendorSKU
 */
export const VendorSKU = new VendorSKU$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomPrintSettings$Type extends MessageType<CustomPrintSettings> {
    constructor() {
        super("rd.product.CustomPrintSettings", [
            { no: 1, name: "paper_width", kind: "message", T: () => Decimal },
            { no: 2, name: "paper_height", kind: "message", T: () => Decimal },
            { no: 3, name: "margin_top", kind: "message", T: () => Decimal },
            { no: 4, name: "margin_bottom", kind: "message", T: () => Decimal },
            { no: 5, name: "margin_left", kind: "message", T: () => Decimal },
            { no: 6, name: "margin_right", kind: "message", T: () => Decimal },
            { no: 7, name: "horizontal_gap", kind: "message", T: () => Decimal },
            { no: 8, name: "vertical_gap", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<CustomPrintSettings>): CustomPrintSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CustomPrintSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomPrintSettings): CustomPrintSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal paper_width */ 1:
                    message.paperWidth = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.paperWidth);
                    break;
                case /* rd.proto.decimal.Decimal paper_height */ 2:
                    message.paperHeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.paperHeight);
                    break;
                case /* rd.proto.decimal.Decimal margin_top */ 3:
                    message.marginTop = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginTop);
                    break;
                case /* rd.proto.decimal.Decimal margin_bottom */ 4:
                    message.marginBottom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginBottom);
                    break;
                case /* rd.proto.decimal.Decimal margin_left */ 5:
                    message.marginLeft = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginLeft);
                    break;
                case /* rd.proto.decimal.Decimal margin_right */ 6:
                    message.marginRight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.marginRight);
                    break;
                case /* rd.proto.decimal.Decimal horizontal_gap */ 7:
                    message.horizontalGap = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.horizontalGap);
                    break;
                case /* rd.proto.decimal.Decimal vertical_gap */ 8:
                    message.verticalGap = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.verticalGap);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomPrintSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal paper_width = 1; */
        if (message.paperWidth)
            Decimal.internalBinaryWrite(message.paperWidth, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal paper_height = 2; */
        if (message.paperHeight)
            Decimal.internalBinaryWrite(message.paperHeight, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_top = 3; */
        if (message.marginTop)
            Decimal.internalBinaryWrite(message.marginTop, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_bottom = 4; */
        if (message.marginBottom)
            Decimal.internalBinaryWrite(message.marginBottom, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_left = 5; */
        if (message.marginLeft)
            Decimal.internalBinaryWrite(message.marginLeft, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal margin_right = 6; */
        if (message.marginRight)
            Decimal.internalBinaryWrite(message.marginRight, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal horizontal_gap = 7; */
        if (message.horizontalGap)
            Decimal.internalBinaryWrite(message.horizontalGap, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal vertical_gap = 8; */
        if (message.verticalGap)
            Decimal.internalBinaryWrite(message.verticalGap, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.CustomPrintSettings
 */
export const CustomPrintSettings = new CustomPrintSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProductVendorSKUsError$Type extends MessageType<UpdateProductVendorSKUsError> {
    constructor() {
        super("rd.product.UpdateProductVendorSKUsError", [
            { no: 1, name: "conflict", kind: "message", T: () => UpdateProductVendorSKUsError_Conflict }
        ]);
    }
    create(value?: PartialMessage<UpdateProductVendorSKUsError>): UpdateProductVendorSKUsError {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateProductVendorSKUsError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateProductVendorSKUsError): UpdateProductVendorSKUsError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.UpdateProductVendorSKUsError.Conflict conflict */ 1:
                    message.conflict = UpdateProductVendorSKUsError_Conflict.internalBinaryRead(reader, reader.uint32(), options, message.conflict);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateProductVendorSKUsError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.UpdateProductVendorSKUsError.Conflict conflict = 1; */
        if (message.conflict)
            UpdateProductVendorSKUsError_Conflict.internalBinaryWrite(message.conflict, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.UpdateProductVendorSKUsError
 */
export const UpdateProductVendorSKUsError = new UpdateProductVendorSKUsError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProductVendorSKUsError_Conflict$Type extends MessageType<UpdateProductVendorSKUsError_Conflict> {
    constructor() {
        super("rd.product.UpdateProductVendorSKUsError.Conflict", [
            { no: 1, name: "vendor_sku", kind: "message", T: () => VendorSKU },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<UpdateProductVendorSKUsError_Conflict>): UpdateProductVendorSKUsError_Conflict {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateProductVendorSKUsError_Conflict>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateProductVendorSKUsError_Conflict): UpdateProductVendorSKUsError_Conflict {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.VendorSKU vendor_sku */ 1:
                    message.vendorSku = VendorSKU.internalBinaryRead(reader, reader.uint32(), options, message.vendorSku);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.product.Product product */ 3:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateProductVendorSKUsError_Conflict, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.VendorSKU vendor_sku = 1; */
        if (message.vendorSku)
            VendorSKU.internalBinaryWrite(message.vendorSku, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 3; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.product.UpdateProductVendorSKUsError.Conflict
 */
export const UpdateProductVendorSKUsError_Conflict = new UpdateProductVendorSKUsError_Conflict$Type();
